import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { IconButton } from '@material-ui/core';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import classNames from 'classnames';
import { useMouseDelta } from 'utils/hooks';


const styles = () => ({
  drawer: {
    marginTop: '-4.625rem',
    borderLeft: '1px solid rgba(0, 0, 0, 0.125);  ',
    padding: '1.875rem',
    overflow: 'auto',
    background: '#fff',
    '& img': {
      maxWidth: '100%',
    },
  },
  dragButton: {
    position: 'absolute',
    marginLeft: '-2.625rem',
    padding: '0.25rem',
    background: '#fff',
    boxShadow: '0px 4px 10px rgba(19, 45, 58, 0.1)',
    '&:hover': {
      background: '#fff',
    },
  },
  dragIcon: {
    transform: 'rotate(90deg)',
    fontSize: '1rem',
  },
});


const PitchDrawer = ({
  classes,
  className,
  children,
}) => {
  const [width, ref] = useMouseDelta(600);
  return (
    <div className={classNames(classes.drawer, className)} style={{ width }}>
      <IconButton className={classes.dragButton} ref={ref}>
        <MenuRoundedIcon className={classes.dragIcon} fontSize="small" />
      </IconButton>
      {children}
    </div>
  );
};

PitchDrawer.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PitchDrawer.defaultProps = {
  className: '',
};

export default withStyles(styles, { withTheme: true })(PitchDrawer);
